/**
 * Canonical, user-facing names for the four audit skills. This is the single source of truth for
 * these four strings — the browser assertions in the plan's acceptance task quote them verbatim,
 * and several components used to each keep their own (drifted) copy. Point every one of those at
 * this constant instead of retyping the string.
 *
 * Zero-import module by design: `npm run test:sam` compiles a plain `node:test` run over `utils/`
 * without the bundler-mode tsconfig, so nothing under this directory may import from outside it
 * (an alias import like `@/shared/ui` would not resolve under that compile).
 */
export const AUDIT_TYPE_LABELS: Record<string, string> = {
  gbp_audit: 'Business profile audit',
  seo_visibility_audit: 'Search visibility audit',
  content_strategy_audit: 'Content opportunity audit',
  site_audit: 'Website audit',
  // The ads agent's read-only runs.
  ad_strategy_review: 'Ad strategy review',
  ad_reporting: 'Weekly ads report',
  // Betty's (reviews) weekly report on text review requests.
  review_funnel_report: 'Weekly reviews report',
  review_funnel_audit: 'Text review funnel check',
};
